import { TabStyles, TextFieldWidget } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';

export type EditPoolNameFieldProps = Readonly<{
  poolName: string;
  onPoolNameChange: (poolName: string) => void;
  hasError: boolean;
  onHasErrorChange: (hasError: boolean) => void;
  existingPoolNames: string[];
}>;

export function EditPoolNameField(props: EditPoolNameFieldProps) {
  const handlePoolNameChange = (value: string) => {
    props.onPoolNameChange(value);
    const hasError = props.existingPoolNames.includes(value);
    props.hasError !== hasError && props.onHasErrorChange(hasError);
  };

  return (
    <div className={fieldClass}>
      <TextFieldWidget
        label={Messages.bridgeSiteSettingsPoolColumnName()}
        value={props.poolName}
        onChange={e => handlePoolNameChange(e.target.value)}
        onClear={() => handlePoolNameChange('')}
        maxLength={80}
        placeholder={Messages.bridgeSiteSettingsPoolNamePlaceholder()}
        testId={'pool-name-text-field'}
        style={{ width: '100%' }}
        className={textFieldClass}
      />
      {props.hasError &&
        <div className={errorClass}>
          {Messages.bridgeSiteSettingsEditPoolNameError()}
        </div>
      }
    </div>
  );
}

const fieldClass = style({ marginBottom: TabStyles.Sizing.BaseUnit * 5 });

const textFieldClass = cssClass('edit-pool-dialog', 'field', {
  width: '100%'
});

export const errorClass = style({ marginTop: TabStyles.Spacing.DefaultSpace, color: TabStyles.Colors.AttentionDark });
